module.exports = __webpack_public_path__ + "static/img/cell-icon1.3338b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dataDownload/cell-icon1.png
// module id = 663
// module chunks = 12